import React from "react";
import "./PortfolioTabs.css";
import { renderIcon } from "../../utils";

const PortfolioTabs = ({ id, title, active, setSelected, Icon=false }) => {
  return (
    <li
      key={id}
      className={active ? "button active" : "button"}
      onClick={() => setSelected(id)}
    >
      {/* Show icon if provided */}
      {Icon && <div className='icon'>{renderIcon(title)}</div>}
      {title} {/* Display the title */}
    </li>
  );
};

export default PortfolioTabs;